export default "__VITE_ASSET__CeHXb4hv__"